import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Alert, Button, Col, Form, Label, Row } from 'reactstrap';
import { AuthLayout, InputField } from 'src/components';
import { useAppSelector } from 'src/rtk/app/hook';
import { useLoginMutation } from 'src/rtk/features/auth/authApi';
import * as Yup from 'yup';

interface LoginProps { }

const InstituteAdminLogin = ({ }: LoginProps) => {
  const signUser = useAppSelector((state) => state.auth);
  const history = useHistory();
  const [signInUser, { data, isLoading, isSuccess, isError, error }] =
    useLoginMutation();

  const user = data?.data;

  const [showPassword, setShowPassword] = useState(true);
  const [isEmailVerified, setIsEmailVerified] = useState<boolean>(true);


  useEffect(() => {
    if (error !== undefined) {
      const errorData = JSON.stringify(error);
      const errorDataParsed = JSON.parse(errorData);
      setIsEmailVerified(errorDataParsed?.data?.email_verified ?? true);
    }
  }, [error]);

  const err = error as CustomError;

  useEffect(() => {
    if (isSuccess && user?.token) {
      history.push('/dashboard');
    }
    if (signUser?.token && signUser?.user?.name) {
      history.push('/dashboard');
    }
  }, [isSuccess]);

  const initialValues: SignInAdmin = {
    login_type: 'Institute-Admin',
    username: '',
    password: '',
    token_name: 'testing',
    remember_me: true,
  };

  const { handleSubmit, handleChange, values, touched, errors } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object({
      username: Yup.string().required('Username is required'),
      password: Yup.string().required('Please Enter Your Password'),
    }),
    onSubmit: (values) => {
      signInUser(values);
    },
  });
  document.title = 'Institute Admin Login | BCPS';

  return (
    <AuthLayout>
      <div className="auth-content my-auto">
        {isError ? (
          <Alert color="danger">
            <div className="d-flex justify-content-between align-items-center">
              {err.message}
              {!isEmailVerified && (
                <Link to="/resend-verification-email">
                  <span className="btn btn-sm btn-primary text-white">
                    Resend Verification Link
                  </span>
                </Link>
              )}
            </div>
          </Alert>
        ) : null}
        <Form
          className="custom-form pt-2"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Row className="justify-content-center">
            <Col>

              <div className="mb-3">
                <Label className="form-label required-field">Username</Label>
                <InputField
                  name="username"
                  type="text"
                  placeholder="Enter your username"
                  onChange={handleChange}
                  value={values.username}
                  invalid={{ errors, touched }}
                />
              </div>

              <div className="mb-3">
                <Label className="form-label required-field">Password</Label>
                <div className="input-group password-input">
                  <InputField
                    name="password"
                    type={showPassword ? 'password' : 'text'}
                    placeholder="Enter password"
                    onChange={handleChange}
                    value={values.password}
                    invalid={{ touched, errors }}
                  />
                  <Button
                      color="light"
                      size="sm"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                    <i
                      className={`${
                        showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'
                      }`}
                    />
                  </Button>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="remember_me"
                      name="remember_me"
                      onChange={handleChange}
                      checked={values.remember_me}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="remember_me"
                    >
                      Remember me
                    </label>
                  </div>

                  <div className="mt-3 d-grid">
                    <button
                      className="btn btn-primary btn-block d-flex gap-2 justify-content-center align-items-center"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading && (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      <span>Log In</span>
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Form>

        <div className="mt-3 text-center">
          <p className="text-muted mb-2">
            New User ?
            {/* <Link to="/registration" className="text-primary fw-semibold ms-3">
              Register
            </Link> */}
            <Link to="/institute-registration" className="btn btn-sm btn-outline-primary fw-semibold ms-3">
              Register as Institute Admin
            </Link>
          </p>
          <p className="text-muted mb-0">
            Forgot Your Password?
            <Link
              to="/forget-password"
              className="btn btn-sm btn-outline-primary fw-semibold ms-3"
            >
              Recover
            </Link>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default InstituteAdminLogin;
